module.exports = __webpack_public_path__ + "img/4064012200.dccfd99d.jpg";